import type { SidebarItem } from 'components/blocks/layout/types/sidebar-conversation';

type ConversationAgentLookup = {
  agentId?: string;
};

export function resolveConversationAgentId(options: {
  conversationId?: string | null;
  agentIdFromUrl?: string | null;
  storeConversation?: ConversationAgentLookup;
  sidebarConversationsList?: SidebarItem[];
}): string | null {
  const { conversationId, agentIdFromUrl, storeConversation, sidebarConversationsList } = options;

  if (agentIdFromUrl) return agentIdFromUrl;

  if (!conversationId) return null;

  if (storeConversation?.agentId) return storeConversation.agentId;

  const sidebarAgentId = sidebarConversationsList?.find(
    (item) => item.ConversationId === conversationId,
  )?.AgentId;

  return sidebarAgentId ?? null;
}

export function isAgentChatConversation(
  options: Parameters<typeof resolveConversationAgentId>[0],
): boolean {
  return !!resolveConversationAgentId(options);
}
